import script from "./ReportsByQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsByQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsByQuestion.vue?vue&type=style&index=0&id=3a209a13&lang=scss"
import "./ReportsByQuestion.vue?vue&type=style&index=1&id=3a209a13&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a209a13"]])

export default __exports__